// Project filters (PD-17094). The server applies each in ProjectsService
// (joinType 'custom').

import { PROJECT_STATUS_LABELS, PROJECT_STATUSES } from '@supply-mover-2-0/shared';
import { createDateRangeFilter, createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

const PROJECT_LIST_KEYS = ['project'];

export const projectFilters: FilterRegistry = {
	projectKeywords: {
		...createKeywordFilter({
			label: 'Keywords',
			placeholder: 'Search project, city, general contractor, owner...',
			objectTable: 'project',
			listKeys: PROJECT_LIST_KEYS,
		}),
		queryParamName: 'projectKeywords',
	},

	projectStatus: {
		type: 'multi-select',
		label: 'Status',
		placeholder: 'Select statuses...',
		colorScheme: 'blue',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		queryParamName: 'projectStatus',
		multiple: true,
		options: PROJECT_STATUSES.map((status) => ({
			id: status,
			label: PROJECT_STATUS_LABELS[status],
		})),
		queryMapping: { objectTable: 'project', joinType: 'custom' },
		format: 'array',
		valueExtractor: {
			property: 'id',
		},
		listKeys: PROJECT_LIST_KEYS,
	},

	projectBidDate: {
		...createDateRangeFilter({
			label: 'Bid Date',
			objectTable: 'project',
			dateField: 'bidDate',
			listKeys: PROJECT_LIST_KEYS,
		}),
		queryMapping: { objectTable: 'project', dateField: 'bidDate', joinType: 'custom' },
		queryParamName: 'projectBidDate',
	},
};
